import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { CircularProgress, CircularProgressProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { brandName } from "../Sidenav";
import { portaleConfig } from "@/portaliConfig";

export default function Loading({
  withBranding = false,
}: {
  withBranding?: boolean;
}) {
  const { t } = useTranslation();
  const imgProps = {
    src: portaleConfig.portaleLogoBackgroundTransparent,
  } as any;
  return (
    <Box py={3} px={3} textAlign="center">
      {withBranding && (
        <Box
          component="img"
          {...imgProps}
          alt={brandName}
          //width="2rem"
          height={60}
          pb={2}
        />
      )}
      {!withBranding && <CircularProgress color="secondary" sx={{ mb: 2 }} />}
      <Typography variant="h6" color="text">
        {t("loading.caricamento")}
      </Typography>
    </Box>
  );
}

export function SmallLoading({ sx }: { sx?: CircularProgressProps["sx"] }) {
  return <CircularProgress color="secondary" size={18} sx={sx} />;
}
